import { createStore } from 'helpers/state';
const sizeStore = createStore({
    notificationHeight: 0,
    headerHeight: 0,
    headerBottom: 0
});
export default sizeStore;
